import apiClient from "./api";

export const getCartItems = (token) =>
  apiClient.get("/cart", {
    headers: {
      authrization: token,
    },
  });

export const addToCart = (data, token) => {
  return apiClient.post("/cart", data, {
    headers: {
      authrization: token,
    },
  });
};

export const changeItemStatus = (data, token) => {
  return apiClient.patch("/cart", data, {
    headers: {
      authrization: token,
    },
  });
};

export const removeFromCart = (itemId, token) => {
  return apiClient.delete(`/cart/${itemId}`, {
    headers: {
      authrization: token,
    },
  });
};

export const clearCart = (token) => {
  return apiClient.delete(`/cart/clearcart`, {
    headers: {
      authrization: token,
    },
  });
};
